import React from "react";

const logline = <p>This is an historical fiction drama that tells the story of a journalist in the late fifties who stumbles over powerful information regarding the second coming of Christ. No one wants to hear about it and he soon finds out why—it may be true.</p>;

export default logline;